import { Link, useNavigate } from "react-router-dom"
import { StatementHeader } from "../../../components/Header/HeaderStatement"
import { NextButtonBlack } from "../../../components/Buttons/NextButtonBlack"
import { useEffect, useState } from "react"
import { getCompletedPayment, setCompleted } from "../../../services"
import { Field, Form, Formik } from "formik"
import { TextareaAutosize } from "@mui/material"
import { DownloadableDocument } from "../../../components/Downloadable/Document"
import { getPurposeStatement, submitPurposeStatement } from "../../../services/statementsService"

export const PurposeStatement = ({ isAtTheEnd = true }) => {
    const navigate = useNavigate();
    const [hasPaid, setHasPaid] = useState(false);
    const [initialValues, setInitialValues] = useState({
        purposeStatement: ''
    });
    // Check if purpose statement has been generated in order to show the Download button so people dont get a blank PDF
    const [generated, setGenerated] = useState(false);

    useEffect(() => {
        getCompletedPayment().then(response => {
            const data = response.data;
            if (data === 1) {
                setHasPaid(true)
            } else {
                setHasPaid(false);
            }
        }).catch(err => {
            console.log(err);
        });

        getPurposeStatement().then(resp => {
            const data = resp.data;
            if (data) {
                setInitialValues({ purposeStatement: data })
                setGenerated(true);
            }
        }).catch(error => {
            console.log(error);
        });
    }, [hasPaid]);

    const handlePrevClick = () => {
        navigate("/flow/purpose/product?step=1")
    }

    const _handleSubmit = values => {
        submitPurposeStatement(values).then(response => {
            // if (hasPaid) {
            //     navigate("/flow/vision");
            // } else {
            //     window.location.href = "/flow/checkout";
            // }
            setCompleted().then(response => {
                navigate("/results");
            }).then(response => {

            }).catch(err => {
                console.error(err);
            })
        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <main className="purpose statement has-yellow-bg">
            <div className="container">
                <StatementHeader step="Purpose" />
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={_handleSubmit}
                >
                    <Form className="flex flex-col gap-8 w-full pt-10">
                        <Field
                            name="purposeStatement"
                            placeholder="The Purpose Statement for your company is being generated. Feel free to edit it in case it doesn't match what you had in mind."
                            as={TextareaAutosize}
                            autoFocus={true}
                        />
                        {/* <p className="statement__paidText">
                            Please consider paying for the product. Close DevTools. <br />
                            Explicabo recusandae temporibus odio. Quos maxime veniam error <br />
                            ab ducimus exercitationem, dolorem soluta consequatur provident eum, <br />
                            omnis cum odit doloribus magni aliquam!
                        </p> */}
                        <p className="text-black text-xl">To see the Vision and Positioning Statements and more, please consider completing the payment.</p>
                        <footer className="statement__footer pt-32 ">
                            {generated && (
                                <DownloadableDocument statement={initialValues.purposeStatement} />
                            )}
                            {isAtTheEnd ? (
                                <div className="statement__footer-container flex-col items-end">
                                    <section>
                                        <span>
                                            Results
                                        </span>
                                        <button className="btn" type="submit">
                                            <NextButtonBlack />
                                        </button>
                                    </section>
                                    <section>
                                        <Link to="/flow/checkout">
                                            <span>
                                                Checkout
                                            </span>
                                            <NextButtonBlack />
                                        </Link>
                                    </section>
                                </div>
                            ) : (
                                <div className="statement__footer-container">
                                    <section>
                                        <button className="btn prev" onClick={handlePrevClick}>
                                            <NextButtonBlack />
                                        </button>
                                        <span>
                                            Product
                                        </span>
                                    </section>
                                    <section>
                                        <span>
                                            Vision
                                        </span>
                                        <button className="btn" type="submit">
                                            <NextButtonBlack />
                                        </button>
                                    </section>
                                </div>
                            )}
                        </footer>
                    </Form>
                </Formik>
            </div>
        </main>
    )
}